import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import {Swiper} from 'swiper'

gsap.registerPlugin(ScrollTrigger)


let timeLineBlocks = $('.timeline-block')

if (timeLineBlocks.length && window.innerWidth > 1200) {
  timeLineBlocks.each((i, block)=> {

    let posts = $(block).find('.post')
    let totPosts = posts.length
    let terms = $(block).find('.posts').data('years-arr')
    let lastYear = terms[0].term_id;
    let lastFirstPart = terms[0].name.substring(0,2)

    let scrollTrigger = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        pin: $(block).find('.year-c')[0],
        start: "top top",
        end: "bottom center",
        scrub: 1,
      }
    });

    $(terms).each((i, term)=> {
      let postsCount = term.count
      let year = $(block).find('.years-second-part [data-term-id="'+term.term_id+'"]')
      let lastYearEl = $(block).find('.years-second-part [data-term-id="'+lastYear+'"]')
      let time = (100 / totPosts) * postsCount
      let firstPart = term.name.substring(0,2)
      let firstPartEl = $(block).find('.years-first-part [data-first-part="'+firstPart+'"]')
      let lastFirstPartEl = $(block).find('.years-first-part [data-first-part="'+lastFirstPart+'"]')

      if (i === 0) {
        time = 0
      } else {
        scrollTrigger.to(lastYearEl, {opacity: 0, top: '-100%', duration: 10}, '>' + time)
      }
      scrollTrigger.to(year, {opacity: 1, top: 0, duration: 10}, '>')

      if (firstPart !== lastFirstPart){
        scrollTrigger.to(lastFirstPartEl, {opacity: 0, top: '-100%', duration: 10}, '<')
        scrollTrigger.to(firstPartEl, {opacity: 1, top: 0, duration: 10}, '<')
        lastFirstPart = firstPart
      }

      lastYear = term.term_id
    })


  })
}



let timeLineBlocksResp = $('.timeline-block-resp')

if (timeLineBlocksResp.length && window.innerWidth < 1200) {
  timeLineBlocksResp.each((i, block)=> {

    let yearsSlider = $(block).find('.js-resp-years-slider')
    let eventsSlider = $(block).find('.js-resp-events-slider')
    let nextB = $(block).find('.js-next-slide')
    let prevB = $(block).find('.js-prev-slide')

    let yearsSwiper = new Swiper(yearsSlider[0], {loop: false});
    let eventsSwiper = new Swiper(eventsSlider[0], {loop: false});

    // navigation buttons
    nextB.click(()=> eventsSwiper.slideNext() )
    prevB.click(()=> eventsSwiper.slidePrev() )

    // slide change event
    eventsSwiper.on('slideChange', (slider)=> {
      let curSlideEl = $(slider.slides[slider.realIndex])
      let curYear = curSlideEl.data('year')
      let activeYearSlide = yearsSlider.find('.swiper-slide-active')
      let activeYear = activeYearSlide.data('year')

      if (curYear !== activeYear){
        let slideNum = yearsSlider.find('[data-year="'+ curYear +'"]').data('slide-index')
        yearsSwiper.slideTo(slideNum)
      }



    });

  })
}
